module.exports = __webpack_public_path__ + "static/media/happiness.e03890ac.svg";